import { takeLatest, put, call, all, fork } from "redux-saga/effects";
import { CaseService } from "services";

import { fetchedCasesCount, failedFetchCasesCount } from "actions";
import { CASE_ACTIONS } from "constants";

function* caseCountFetchHandler(action) {
    try {
        // `view` from the fetchCasesCount action ("assigned" → only cases
        // whose live task's this_user==me → powers "My Cases" per-stage
        // badges; anything else → historical total-per-stage counts).
        const view = (action && action.payload && action.payload.view) || null;
        const [
            { data: inboxCount, error: inboxError },
            { data: participatedCount, error: participatedError }
        ] = yield all([
            call(CaseService.getCasesCount, "inbox", view),
            call(CaseService.getCasesCount, "participated", view)
        ]);
        if (!(inboxError && participatedError)) {
            yield put(
                fetchedCasesCount({
                    INBOX: inboxCount,
                    PARTICIPATED: participatedCount
                })
            );
        } else {
            yield put(failedFetchCasesCount(inboxError || participatedError));
        }
    } catch (error) {
        console.error(error);
    }
}

export default fork(function*() {
    yield takeLatest(CASE_ACTIONS.FETCH_CASES_COUNT, caseCountFetchHandler);
});
